import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function ExistingAccount() {
  return (
    <div className="rounded-md border border-border p-3">
      <p className="text-center text-sm font-normal text-muted">
        Already have an account?{" "}
        <Button variant="link" className="h-auto p-0" asChild>
          <Link to="/sign-in">Sign in</Link>
        </Button>
      </p>
    </div>
  );
}
